import { Models } from '@rematch/core';
import count from './count';
import auth from './auth';
import resetPassword from '@pc/modules/resetPassword/model';
import forgotPassword from '@pc/modules/forgotPassword/model';
import setPassword from '@pc/modules/setPassword/model';

import UsersModel from '@pc/modules/setting/model';
import DocumentModel from '@pc/modules/document/model';
import LpManagementModule from '@pc/modules/lp-management-module/model';
import LpManagementGroupModule from '@pc/modules/lp-management-module/groupModel';
import SetPermissionsModel from '@pc/modules/set-permissions/model';
import SetPermissionsAlertModel from '@pc/modules/set-permissions-alert/model';
import LpMonitorModel from '@pc/modules/lpMonitor/model';

import { connect as reduxConnect } from 'react-redux';

export interface RootModel extends Models<RootModel> {
  count: typeof count;
  auth: typeof auth;
  resetPassword: typeof resetPassword;
  setPassword: typeof setPassword;
  forgotPassword: typeof forgotPassword;
  UsersModel: typeof UsersModel;
  DocumentModel: typeof DocumentModel;
  LpManagementModule: typeof LpManagementModule;
  LpManagementGroupModule: typeof LpManagementGroupModule;
  SetPermissionsModel: typeof SetPermissionsModel;
  SetPermissionsAlertModel: typeof SetPermissionsAlertModel;
  LpMonitorModel: typeof LpMonitorModel;
}

export const models = {
  count,
  auth,
  resetPassword,
  setPassword,
  forgotPassword,
  UsersModel,
  DocumentModel,
  LpManagementModule,
  LpManagementGroupModule,
  SetPermissionsModel,
  SetPermissionsAlertModel,
  LpMonitorModel,
};

export const connect: any = reduxConnect;
